/** @jsx jsx */
import RichText from "@src/components/RichText"
import PropTypes from "prop-types"
import { jsx, Styled } from "theme-ui"

function Answer({ answer, glossary }) {
  return (
    <div
      sx={{
        pb: 7,
        px: [0, 8],
        opacity: "1",
        maxWidth: "768px",
        transition: "opacity 0.2s ease-in-out",
        animation: `fadeIn 0.2s ease-in-out`,
        "@keyframes fadeIn": {
          "0%": {
            opacity: 0,
          },
          "100%": {
            opacity: 1,
          },
        },
      }}
    >
      {glossary ? (
        <RichText json={glossary.json} />
      ) : (
        <Styled.p sx={{ whiteSpace: "pre-wrap" }}>{answer?.answer}</Styled.p>
      )}
    </div>
  )
}

Answer.propTypes = {
  answer: PropTypes.shape({
    id: PropTypes.string,
    answer: PropTypes.string,
  }),
  glossary: PropTypes.shape({
    id: PropTypes.string,
    json: PropTypes.object,
  }),
}

export default Answer
